module.exports = __webpack_public_path__ + "img/375.f395626e.jpg";